import { AspectBox, Box } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";

export default () => (
	<CssColumnGrid columns={2}>
		<Box width={300}>
			<AspectBox bgcolor="red" />
		</Box>
		<Box width={200}>
			<AspectBox aspectRatio={2} bgcolor="blue" />
		</Box>
	</CssColumnGrid>
);